import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const DeliveryAddress = ({
  deliveryAddress: {
    attributes: { street, street_two, city, state, zip_code, is_doorman, notes },
  },
  isVerifyPage,
}) => {
  return (
    <div className={classNames(styles.component, 'inspectlet-sensitive')}>
      <div>
        <p>{street}</p>
        <p>{street_two}</p>
        <p>
          {city}, {state} {zip_code}
        </p>
      </div>
      <div className={styles.rest}>
        {is_doorman && !isVerifyPage && <span className={styles.doorman}>Leave with Doorman</span>}
        {notes && !isVerifyPage && <p className={styles.doorman}>{notes}</p>}
      </div>
    </div>
  );
};

DeliveryAddress.propTypes = {
  deliveryAddress: PropTypes.shape({
    zip_code: PropTypes.string,
    street: PropTypes.string,
  }),
};

export default DeliveryAddress;
